import React from "react";
import { auth } from "../firebase"; // Import your Firebase authentication instance
import { Container, Col, Row, Button } from "react-bootstrap";
import htmlTemplateGuest from "../Email/htmlTemplateGuest";
//import renderMJMLTemplate from "../Email/EmailTemplate";
import { useState } from "react";
import ManWalking from "../images/man-walking.jpg";

const SignOut = ({ user, setUser }) => {
  const [emailSent, setEmailSent] = useState(false);
  //const [emailToSend, setEmailToSend] = useState("");

  const emailToSend = sessionStorage.getItem("email");
  console.log("Email to send:", emailToSend);

  const handleSendMailWithResend = async () => {
    console.log("Resend clicked");
  };

  // *****************
  //   NEW FUNCTION
  // *****************

  const sendMyEmail = async (emailAddress, htmlTemplate) => {
    console.log("HTML Template is:", htmlTemplate);
    const firstName = sessionStorage.getItem("firstName");
    try {
      const response = await fetch(
        "https://us-central1-guest-artist-showcase-2024.cloudfunctions.net/sendEmail",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: emailAddress,
            htmlTemplate: htmlTemplate(firstName),
          }), // Send the email address in the request body
        }
      );

      const responseData = await response.json(); // Assuming your cloud function returns JSON

      if (responseData.status === "ok") {
        console.log("Email sent successfully");
        setEmailSent(true);
        handleSignOut();
      } else {
        console.error("****Error sending email");
      }
    } catch (error) {
      console.error("arrrrrrgggg   Error:", error);
    }
  };

  //const navigate = useNavigate();
  const handleSignOut = async () => {
    try {
      await auth.signOut();
      setUser(null);
      localStorage.removeItem("fullName");
      // You can perform additional actions after signing out, like redirecting the user or updating the UI.
    } catch (error) {
      console.error("Error signing out:", error);
    }
  };

  handleSignOut();

  return (
    <>
      <Container className='mt-4'>
        <Row className='mt3 d-flex align-items-center'>
          <Col lg={6} className='text-center'>
            <img src={ManWalking} alt='Artist Showcase' className='img-fluid' />
          </Col>
          <Col lg={6} className='whiteText mt-4 '>
            <h1>Submission Saved </h1>
            <div>
              {emailSent ? (
                <p>
                  Thanks for your interest in our Guest Artist Showcase. Please
                  check your in box for confirmation and handy links! We'll be
                  in touch for next steps.
                </p>
              ) : (
                <>
                  {/* <Button
                    onClick={() =>
                      sendMyEmail(
                        emailToSend,
                        htmlTemplateGuest
                        // "<h1>Default Email</h1>"
                      )
                    }>
                    Send Email Reminder
                  </Button> */}
                </>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default SignOut;
